// ADM-6 — the permission words the app checks for (pulled from the code, Oct 23 2026), in plain words.
// Anything else on an account (the brand name, retired words) is shown as a read-only tag and kept.

export type PermissionInfo = { id: string; label: string; note?: string };

export const APP_PERMISSIONS: PermissionInfo[] = [
  { id: "sites", label: "Sites" },
  { id: "pages", label: "Pages" },
  { id: "funnels", label: "Funnels" },
  { id: "forms", label: "Forms" },
  { id: "crm", label: "CRM" },
  { id: "insights", label: "Insights" },
  { id: "agents", label: "Agents", note: "Also makes Agents their home screen after login." },
  { id: "reviews", label: "Reviews", note: "Launch Reviews: their review rooms. Admins always see it." },
  { id: "inbox", label: "Inbox", note: "Launch Inbox: the team inbox for email and website chat." },
  { id: "concierge", label: "Concierge", note: "Also makes Concierge their home screen after login." },
  { id: "content", label: "Content" },
  { id: "collections", label: "Collections" },
  { id: "media", label: "Media" },
  { id: "blogs", label: "Blogs" },
  { id: "cart", label: "Cart" },
  { id: "member", label: "Membership" },
  { id: "webinar", label: "Webinar" },
  { id: "social", label: "Social" },
  { id: "wildfire", label: "Wildfire" },
  { id: "workflows", label: "Workflows" },
  { id: "partnerships", label: "Partnerships" },
  { id: "partnerPortal", label: "Partner Portals" },
];

export const ADVANCED_PERMISSIONS: PermissionInfo[] = [
  { id: "launchOS", label: "Launch OS menus", note: "Support menu, Planning, and parts of Settings." },
  { id: "copilot", label: "Copilot button", note: "Shows the Copilot helper button." },
  { id: "withAI", label: "Build with AI", note: "Build with AI button in page wireframes." },
  { id: "sketchpad", label: "Sketch Pad", note: "Sketch Pad tab inside a funnel." },
  { id: "vision", label: "Vision tab", note: "An extra tab inside a funnel." },
  { id: "freemium", label: "Free account", note: "Pages shows upgrade pop-ups." },
  { id: "scroll", label: "CRM-first", note: "Hides Planning; they land on CRM contacts after login." },
];

const KNOWN = new Set([...APP_PERMISSIONS, ...ADVANCED_PERMISSIONS].map((p) => p.id).concat(["admin", "bot"]));

// words on an account the screen has no switch for (shown read-only, never removed by the screen)
export const otherPermissions = (perms: string[]) => perms.filter((p) => !KNOWN.has(p));
